export default "__VITE_ASSET__MJr$9QBY__"